import { pricingApi } from "../config/apiConfig";

export const getPriceByStationId = async (id) => {
  try {
    const response = await pricingApi.get(`/locations/${id}/tariffs`);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const getPricesAC = async () => {
  try {
    const response = await pricingApi.get(`/tariffs/default`);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const getPricesDC = async () => {
  try {
    const response = await pricingApi.get(`/tariffs/default_DC`);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const updatePrice = async (data, id) => {
  try {
    const response = await pricingApi.put(`/tariffs/${id}`, data);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const getAllCommunityPrices = async () => {
  try {
    const response = await pricingApi.get("/static-tariff/tariffs");
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
export const getPricingHistoryForLocation = async (locationId) => {
  try {
    const response = await pricingApi.get(`/static-tariff/tariffs/history/${locationId}`)
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}